import React from 'react';
import ResponsiveWrapper from '../ResponsiveWrapper';
import Navigator from './index';
import MobileNavigator from './MobileNavigator';

const ResponsiveNavigator = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileNavigator />}
      desktop={<Navigator />}
    />
  );
};

export default ResponsiveNavigator;